import React from 'react'
import DynamicSkeleton from '../../components/DynamicSkeleton'
import Skeleton from 'react-loading-skeleton'

const columnConfig = {
  ID: {content:<Skeleton height="20px" width="70px" />, center: true},
  "User Details": {content:<Skeleton height="50px" width="140px" />, center: false},
  "Station Name": {content:<Skeleton height="20px" width="110px" />, center: true},
  "Connector Type": {content:<Skeleton height="50px" width="60px" />, center: true},
  "Status": {content:<Skeleton height="20px" width="80px" />, center: true},
  "Booking Date": {content:<Skeleton height="20px" width="60px" />, center: true},
  Amount: {content: <Skeleton height="20px" width="60px" />, center:true},
  "Payment method": {content: <Skeleton height="30px" width="50px" />, center: true},
}

const BookingManagementSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default BookingManagementSkeleton